<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons slot="start">
          <ion-back-button  v-if="viewmode && manageUser" default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-back-button   v-if="!manageUser" default-href="#" @click="navigatePreviousPage"></ion-back-button>
        </ion-buttons>
          <ion-title v-if="!manageUser">Manage Branches / <span class="ion-sub-title">{{branchId}}</span> </ion-title>
          <ion-title  v-if="!viewmode && manageUser">Manage Users to a branch / <span class="ion-sub-title">{{details}}</span> </ion-title>
          <ion-buttons slot="end">
            <ion-button @click="editCorporateDetails"  v-if="viewmode && editInd" class="hdrBtn">
              EDIT
          </ion-button>
          <ion-button @click="viewAssociatedStations"    v-if="viewmode && editInd" class="hdrBtn">
            View Associated Stations
          </ion-button>
          <ion-button @click="manageUsersBranch" v-if="branchId == 'new' || branchId == 'Detail'" class="hdrBtn">
            Manage Users
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <BranchDetails  v-if="!viewmode"/>
      <BranchView  v-if="viewmode"/>
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src

import BranchDetails from "@/components/corporate/branchDetails.vue";
import BranchView from "@/components/corporate/branchView.vue";
// import ManageUsersToBranch from "@/components/corporate/manageUsersToBranch.vue";
import { flash, journal } from 'ionicons/icons';
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from "@ionic/vue";
import { AppUtils } from "@/util/app-utils";

export default defineComponent ({
  name: 'branchDetails',
  components: {
      BranchDetails, BranchView, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonButton, IonContent
      // ManageUsersToBranch
  },
  data() {
    return {
      rightToUpdate: false,
      viewmode: false,
      manageUser: false,
      branchId: "New",
      details: "List",
      editInd: false,
      manageUserInd: false,
      associatedStationInd: false,
      userBranchSearch: null
    }
  },
  async mounted() {
    
    let roleId = localStorage.getItem('user.roleId');
    /*
    if(roleId == 4) {
      // CPO Admin
      this.editInd = false
      // CPO Changes and given access to add users
      // this.associatedStationInd = false
      this.associatedStationInd = true;
      this.manageUserInd = false;
      // let manageUser = localStorage.getItem("manageUserInd");
      // if(manageUser == "true") {
      //   this.manageUserInd = false
      // } else {
      //   this.manageUserInd = true
      // }
    } else {
      // Fenfeo Admin
      this.editInd = true
    }
    // let userBranchSearch = JSON.parse(localStorage.getItem('userBranchSearch'));
    
    */
    this.rightToUpdate = new AppUtils().getUserAccess("100|U");
   if(this.rightToUpdate) {
      this.editInd = true;
    } else {
      this.editInd = false;
      this.associatedStationInd = true;
    }
    this.userBranchSearch = JSON.parse(localStorage.getItem('branchInfo'));
   
    if(this.userBranchSearch != null) {
      let id = this.userBranchSearch.branchId;
      // this.$route.params.corporateId = id;
      this.viewmode = true;
      this.branchId = "Detail";
      localStorage.removeItem('userBranchSearch');
    } else {
  
    }
    // if (this.userBranchSearch != null) {
    //   if (this.$route.query.mode) {
    //     this.viewmode = false;
    //     this.branchId = "Edit";
    //   } else {
    //     this.viewmode = true;
    //     this.branchId = "Detail";
    //   }
    // }
    
    
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    editCorporateDetails() {
      this.viewmode = false;
      this.branchId = "Edit";
    },
    manageUsersBranch() {
      
      this.$router.push({
        name: "manageUserToBranch",
        params: { corporateId: this.userBranchSearch.corporateId }
      });
    },
    // async navigateToBranchDetails() {
      
    // },
    viewAssociatedStations() {
      this.$router.push({
        name: "cpoChargingStations",
        params: { corporateId: this.$route.params.corporateId }
      });
    }
  }
})
</script>